// extracted by mini-css-extract-plugin
export const other_services = "OtherServices-module--other_services--2cKoI";
export const services_button = "OtherServices-module--services_button--3woVj";
export const wiggleRight = "OtherServices-module--wiggle-right--1H1ol";
export const buttons = "OtherServices-module--buttons--1llUd";
export const bouncy = "OtherServices-module--bouncy--1KIdV";
export const pop = "OtherServices-module--pop--2aaGb";